// accepted file types can be loaded from server
export const validateFile = (file: File) => {
  const validTypes = [
    "",
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/gif",
    "image/x-icon",
    "image/svg+xml",
    "text/plain",
    "text/csv",
    "text/xml",
    "application/pdf",
    "application/msword",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    "application/vnd.oasis.opendocument.spreadsheet",
    "application/x-zip-compressed",
  ];

  const invalidTypes = ["application/x-msdownload"];

  if (validTypes.indexOf(file.type) === -1) return false;

  if (invalidTypes.indexOf(file.type) !== -1) return false;

  return true;
};

export const fileSize = (size: number) => {
  if (size === 0) {
    return "0 Bytes";
  }
  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  const i = Math.floor(Math.log(size) / Math.log(k));
  return `${parseFloat((size / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
};

export const fileType = (fileName: string) => {
  return fileName.substring(fileName.lastIndexOf(".") + 1, fileName.length) || fileName;
};
